import { FormCollapsibleSection, FormSectionIcons } from '@editorComponents'
import GeneralizedPositionCreation from '../GeneralizedPositionCreation'

interface Props {
  selectedElement: string
}

const Actions = ({ selectedElement }: Props) => {
  return (
    <>
      <FormCollapsibleSection
        label="Dachpositionen erzeugen"
        startIcon={FormSectionIcons.actions}
        defaultExpanded={true}
      >
        <GeneralizedPositionCreation selectedElement={selectedElement} />
      </FormCollapsibleSection>
    </>
  )
}

export default Actions
